<template>
  <div class="lms-wrapper-two">

    <student-nav @route-changed="toggleNavbar(false)">
                <!-- <notif-search
                  v-if="searchRdy"
                  :searches="searches"
                  :tasks="tasks"
                  :allCount="allCount"
                  class="mg-t-40"
                  @on-search="search($event)"
                  @on-reset="init(true)"
                  :key="searchKey"
                /> -->

                <task-searches
                  ref="srchFields2"
                  :searches="searches"
                  :filterModelProp="filterModel"
                  @on-search="onSearchFired"
                ></task-searches>

                <div class="btn-group mg-y-7" role="group" aria-label="Basic example">
                  <button title="Хайх" alt="Хайх"
                    @click="$refs.srchFields2.filter()"
                    type="button"
                    class="btn btn-xs btn-outline-light"
                  >
                    <feather type="filter" size="32" class="mg-r-5"></feather>
                    <span>Хайх</span>
                  </button>
                  <button title="Бүгд" alt="Бүгд"
                    @click="$refs.srchFields2.reset()"
                    type="button"
                    class="btn btn-xs btn-outline-light"
                  >
                    <feather type="refresh-ccw" class="mg-r-5"></feather>
                    <span>Бүгд</span>
                  </button>
                </div>

              </student-nav>

    
    <!-- <div class="lms-sidebar">
      <div class="lms-sidebar-body">
        <vue-custom-scrollbar :style="`height: ${getScrollHeight()}`">
          <div :class="`card ${$store.state.app.isMobile ? 'bd-0' : ''}`">
            <div class="card-body">
              
            </div>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div> -->
    <div class="lms-content">
      <student-header
      @toggle-navbar="toggleNavbar($event)"
      :navbarmode.sync="navbarMode"
    />

      

      <div class="lms-content-body container" style="bottom: 0; height: calc(100vh - 80px)">
        <section v-if="$route.params.id == 0">
          <vue-custom-scrollbar
            :style="`height: ${getScrollHeight()}`"
            class="bg-white"
          >
            <template v-if="$store.state.app.isMobile">
              <div class="card" style="min-height: 100%">
                <div
                  class="card-header d-flex align-items-center justify-content-between"
                >
                  <h6 class="mg-b-0">Машинчийн санамж</h6>
                </div>
                <ul class="list-group list-group-flush tx-13">
                  <li
                    @click="showTask(t)"
                    :class="`list-group-item d-flex clearfix pd-sm-x-20 ${t.isCompleted?'bg-success text-white':''}`"
                    v-for="(t, i) in tasks"
                    :key="i"
                  >
                    <!-- <div class="avatar" style="min-width: 40px">
                      <span
                        v-if="t.locTypeName != null && t.locTypeName != ''"
                        class="avatar-initial rounded-circle bg-info"
                      >
                        {{ t.locTypeName.substring(0, 1) }}
                      </span>
                      <span
                        v-else
                        class="avatar-initial rounded-circle bg-gray-600"
                        ><feather type="list" class="ht-20-f wd-20-f"></feather
                      ></span>
                    </div> -->
                    
                    <div class="pd-l-10">
                      <p class="tx-medium mg-b-0">{{ t.task }} <span v-if="t.organizationTask!=null"> / {{ t.organizationTask.task }}</span></p>
                      <small :class="`tx-12 ${t.isCompleted ? '' : 'tx-color-03' } mg-b-0`">{{
                        t.departName
                      }}</small>
                    </div>
                    
                      <div v-if="t.defaultAttachmentId!=null && t.defaultAttachmentId>0" class="mg-l-auto">
                        <a role="button" @click.stop="showFile(t.defaultAttachmentId)">
                          <feather type="paperclip" class="mg-r-5"></feather>
                          харах
                        </a>
                      </div>
                  </li>
                </ul>
              </div>
            </template>
            <template v-else>
              <table
                class="table table-striped table-hover table-sm table-responsive wd-100p"
              >
                <thead>
                  <tr>
                    <th scope="col" class="wd-50">Д/д</th>
                    <th scope="col">Зөрчил дутагдал</th>
                    <th scope="col">Галт тэрэг / Зүтгүүр</th>
                    <th scope="col">Өртөө зөрлөг</th>
                    <th scope="col">Илэрсэн огноо</th>
                    <th scope="col">Байгууллага</th>
                    <!-- <th scope="col" class="wd-90">-</th> -->
                  </tr>
                </thead>
                <tbody v-if="tasks.length">
                  <tr
                    @click="showTask(t)"
                    v-for="(t, i) in tasks"
                    :key="i"
                    :class="`${t.isCompleted?'bg-success text-white':''}`"
                    role="button"
                  >
                    <th scope="row" class="tx-color-03">{{ i + 1 }}</th>
                    <td class="font-weight-bolder">{{ t.locType1Name }}</td>
                    <td>
                      {{ t.task }} 
                      <span v-if="t.organizationTask!=null"> / {{ t.organizationTask.task }}</span>
                      <div v-if="t.defaultAttachmentId!=null && t.defaultAttachmentId>0" >
                        <a role="button" @click.stop="showFile(t.defaultAttachmentId)" class="btn btn-xs btn-primary">
                          <feather type="paperclip" class="mg-r-5"></feather>
                          харах
                        </a>
                      </div>
                    </td>
                    <td class="tx-color-03">{{ t.locTypeName }}</td>
                    <td class="tx-color-03">
                      {{ t.d1 | moment('YYYY.MM.DD') }} 
                      <sup>{{ t.d1 | moment('HH:mm') }}</sup>
                    </td>
                    <td class="tx-color-03">{{ t.departName }}</td>
                    <!-- <td>
                      
                    </td> -->
                  </tr>
                </tbody>
                <tbody v-else-if="isLoading">
                  <tr>
                    <td colspan="5" class="wd-100p">
                      <div
                        class="container d-flex justify-content-center ht-100p"
                      >
                        <div
                          class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center pd-t-100"
                        >
                          <div class="wd-80p wd-sm-300 mg-b-15">
                            <img
                              src="assets/svg/boxempty.svg"
                              alt=""
                              class="img-fluid"
                            />
                          </div>
                          <h4 class="tx-20 tx-sm-24 text-muted">
                            түр хүлээнэ үү
                          </h4>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="5" class="wd-100p">
                      <div
                        class="container d-flex justify-content-center ht-100p"
                      >
                        <div
                          class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center pd-t-100"
                        >
                          <div class="wd-80p wd-sm-300 mg-b-15">
                            <img
                              src="assets/svg/boxempty.svg"
                              alt=""
                              class="img-fluid"
                            />
                          </div>
                          <h4 class="tx-20 tx-sm-24 text-muted">
                            Мэдээлэл хоосон байна
                          </h4>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </template>
          </vue-custom-scrollbar>
          <!-- <div v-if="$store.state.app.isMobile" class="position-fixed b-0 l-0">search here</div> -->
        </section>
        <section v-if="$route.params.id > 0">
          <div class="mg-b-20 pd-b-10 bd-b d-flex align-items-center">
            <router-link
              :to="{
                name: 'lmsNotif',
                params: { id: 0, cid: 0, title: 'Тушаал Цахилгаан' }
              }"
            >
              <feather type="chevron-left" class="mg-r-10"></feather>
            </router-link>
            <h6 class="tx-uppercase tx-semibold mg-b-0 wd-80p">
              {{ $route.params.title }}
            </h6>
            <div class="d-flex align-items-center  wd-20p">
              <div class="mg-l-auto">
                <a
                  v-if="fileData.fetched"
                  target="_blank"
                  :href="fileData.link"
                  class="btn btn-xs btn-success"
                  ><feather type="download"></feather> татах</a
                >
              </div>
            </div>
          </div>

          <file-preview
            @on-data-fetched="fileDataFetched"
            :id.sync="$route.params.id"
            :params="$route.params"
            force
            :minusHeight="$store.state.app.isMobile ? 140 : 180"
          />
        </section>

        <div class="pd-t-5 d-flex">
          <a @click="searchShow()" role="button" class="btn btn-secondary tx-white">Хайх</a>
          <a @click="editShow(0)" role="button" class="mg-l-auto btn btn-primary tx-white">Шинэ санамж нэмэх</a>
        </div>
      </div>
    </div>

    <task-dialog
      v-if="tskDetail.id > 0"
      :id.sync="tskDetail.id"
      @on-task-close="tskDetail.id = 0"
      :detailSettingProp="{
        hideMainMenu: true,
        hideRightSidebar: false,
        boxSetting: { hideToolbar: true, listSetting: { disableDetail: true } }
      }"
    ></task-dialog>
    <!-- @on-attach="showFile($event)"
      @on-task-posted="taskPosted"
    -->
    <task-edit
      :prms.sync="taskEdit"
      :show.sync="taskEdit.show"
      :disablePreEditCheck="true"
      @on-task-posted="taskPosted"
      @on-edit-close="editClosed"
    ></task-edit>

    <file-dialog
      :show.sync="fileDialog.show"
      :id="fileDialog.id"
      @on-hide="fileDialog.show = false"
    />

    <b-sidebar
      right
      shadow
      backdrop
      v-model="srchBar"
      width="100%"
      prop
    >
      <task-searches
        ref="srchFields"
        :searches="searches"
        :filterModelProp="filterModel"
        @on-search="onSearchFired"
      ></task-searches>


        <div class="btn-group mg-y-7" role="group" aria-label="Basic example">
          <button title="Хайх" alt="Хайх"
            @click="$refs.srchFields.filter()"
            type="button"
            class="btn btn-xs btn-outline-light"
          >
            <feather type="filter" size="32" class="mg-r-5"></feather>
            <span>Хайх</span>
          </button>
          <button title="Бүгд" alt="Бүгд"
            @click="$refs.srchFields.reset()"
            type="button"
            class="btn btn-xs btn-outline-light"
          >
            <feather type="refresh-ccw" class="mg-r-5"></feather>
            <span>Бүгд</span>
          </button>
        </div>
    </b-sidebar>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";

import { request } from "@/api/all";
export default {
  components: {
    vueCustomScrollbar,
    taskSearches: () => ({
      component: import("@/components/project/searches.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),

    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    notifSearch: () => ({
      component: import(
        "@/views/modules/lms/student/pages/sanamj/components/search.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    filePreview: () => ({
      component: import("@/components/modules/media/previewPage.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),

    taskDialog: () => ({
      component: import("@/components/task/detail/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    taskEdit: () => ({
      component: import("@/components/task/edit/base"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    return {
      navbarMode: 0,
      tasks: [],
      allCount: 0,
      searches: [],
      searchRdy: false,
      searchKey: 0,
      filterModel: {
        task: "",
        systemFlag: null
      },
      isLoading: false,
      fileData: {
        fetched: false,
        link: ""
      },

      tskDetail: {
        id: 0
      },

      fileDialog: {
        show: false,
        id: 0
      },

      taskEdit: {
        id: 0,
        show: false,
        render: false,
        objectTypeId: 559,
        projectId: 0
      },
      srchBar: false,
    };
  },
  mounted() {
    this.toggleBodyClass("addClass", "app-lms");
    require("@/assets/css/dynamic.lms.css");
    this.init();
    this.initSearches();
  },
  destroyed() {
    this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    onSearchFired(e) {
      console.log('e', e);
      this.filterModel = e;
      this.srchBar= false;
      this.init();
    },
    searchShow(){
      this.srchBar= true;
    },
    editShow(id) {
      this.taskEdit.id = id;
      this.taskEdit.objectTypeId = 559;
      this.taskEdit.projectId = 56872;
      this.taskEdit.render = true;
      this.$nextTick(function() {
        this.taskEdit.show = true;
      });
    },
    editClosed() {
      this.taskEdit.render = false;
      this.taskEdit.show = false;
      this.taskEdit.id = 0;
    },
    taskPosted(e) {
      this.editClosed();
      this.init();
      // this.showTaskDetail(e.obj.id);
    },

    showFile(id) {
      this.fileDialog.id = id;
      this.fileDialog.show = true;
    },
    showTask(t){
      this.tskDetail.id = t.id;
    },
    fileDataFetched(e) {
      this.fileData.link = e.data.file.link;
      this.fileData.fetched = true;
      //console.log(e);
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    getScrollHeight() {
      let mh = 130;
      if (screen.width <= 1024) {
        mh = 125;
      }
      return `calc(${window.innerHeight}px - ${mh}px) !important;`;
    },
    search(e) {
      this.navbarMode = 1;
      this.toggleNavbar(false);
      if (this.$route.params.id > 0) {
        this.$router.push({
          name: "lmsNotif",
          params: { id: 0, cid: 0, title: "Тушаал Цахилгаан" }
        });
      } else {
        this.filterModel = e;
        this.init();
      }
    },
    init(force) {
      // if (force) {
      //   if (this.$route.params.id > 0) {
      //     this.$router.push({
      //       name: "lmsNotif",
      //       params: { id: 0, cid: 0, title: "Тушаал Цахилгаан" }
      //     });
      //   } else {
      //     this.filterModel = { task: "", systemFlag: null };
      //     this.searchKey++;
      //     this.navbarMode = 1;
      //     this.toggleNavbar(false);
      //   }
      // }

      this.isLoading= true;
      this.allCount = 0;
      this.tasks = [];

      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 300,
          ot: 559,
          model: this.filterModel
        },
        store: this.$store
      }).then(res => {
        this.isLoading= false;
        if (res != false) {
          //console.log(res);
          this.allCount = res.data.allCount;
          this.tasks = res.data.tasks;
        }
      });
    },
    initSearches() {
      request({
        api: { method: "GET", url: "TaskCore/GetSearchFields" },
        params: {
          objectTypeId: 559
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.searches = res.data.fields.map(e =>
            Object.assign(e, { val: "" })
          );
          this.searchRdy = true;
        }
      });
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
    }
  },
  watch: {
    "$root.$route"(newRoute, oldRoute) {
      if (newRoute.params.cid != oldRoute.params.cid) {
        this.$nextTick(() => {
          this.init();
        });
      }
    }
  }
};
</script>

<style></style>
